module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/432a1e6901cfec53c3751219a587a6a7.png";